export default {
  user: {
    subtitle: "年度回顧",
    note: `*報告中所有數據統計截止至2024-12-31`,
  },

  handCard: {
    text: `{1}
    是你在2024年第一次打開KKPoker的時間`
      .replace("{1}", "{date}")
  },

  report: {
    loginTime: `從那一刻起，KKPoker陪你度過了
    {2}天`.replace("{2}", "{loginDay}"),
    loginTips: `*你有登入KKPoker的天數`,
    enjoyTime: `{3}
    是你一天中最享受的時間，你最喜歡在這個時候打開KKPoker。`
      .replace("{3}", "{loginTime}"),
    firstHandDate: `{4}
    在{5}牌桌上，你拿到了2024年的第一手牌
    {6}`
      .replace("{4}", "{first_hand_date}")
      .replace("{5}", "{first_hand_type}")
      .replace("{6}", "{first_hand_cards}"),
    firstClash: `{7}
    在KKClash牌桌上，你下注了2024年的第一顆籌碼。`
      .replace("{7}", "{first_clash_date}")
  },

  hands: {
    v1: `2024年，你在KKPoker上打了
    {8}手牌
    你對撲克牌的熱愛戰勝了
    {9}
    的玩家`
      .replace("{8}", "{kk_hands_num}")
      .replace("{9}", "{kk_win_num}"),
    v2: `2024年，你在KKPoker打了
    {8}手牌
    感謝你的陪伴！`.replace("{8}", "{kk_hands_num}"),
    v3: `2024年，你在KKPoker打了
    {8}手牌
    新的一年KKPoker會努力做得更好！`.replace("{8}", "{kk_hands_num}"),
    hardTime: `其中，{10}
    是你最努力的一天
    在這一天，你總共打了
    {11}手牌`
    .replace("{10}", "{one_day_hands}")
    .replace("{11}", "{one_day_hands_num}")
  },

  favoriteGame: `而你最投入的遊戲是
  {12}
  在這個玩法你總共打了
  {13}手牌`
    .replace("{12}", "{game}")
    .replace("{13}", "{hands}"),

  kkWin: {
    v1: `2024年你一共拿到了
    {14}手K-K
    其中有
    {15}次
    你和KK一起，戰勝了你的對手。`
      .replace("{14}", "{all}")
      .replace("{15}", "{win}"),
    v2: `2024年你總共all-in了
    {16}次
    all-in勝率
    {17}
    撲克，是勇者的遊戲！`
      .replace("{16}", "{all}")
      .replace("{17}", "{percentage}"),
    
  },

  achievement: {
    spinup: `{18}
    是你最幸運的一天
    在這一天，你在SpinUp搖出了{19}，獲得獎金
    {20}`
      .replace("{18}", "{spinup_date}")
      .replace("{19}", "{spinup_ratio}")
      .replace("{20}", "{spinup_reward}"),
    mtt: `{21}
    是你最閃耀的一天
    你贏下了
    {22}的
    第{23}名
    獲得獎金
    {24}`
      .replace("{21}", "{mtt_date}")
      .replace("{22}", "{mtt_name}")
      .replace("{23}", "{mtt_rank}")
      .replace("{24}", "{mtt_reward}"),
    rg: `{25}
    是你最精彩的一天
    在這一天
    你贏下了今年最大的底池
    {26}`
      .replace("{25}", "{rg_date}")
      .replace("{26}", "{rg_reward}")
  },

  kkclash: {
    text: '在2024年，KKClash是你最鍾愛的遊戲。 新的一年，KKPoker的其它遊戲也會努力做得更好！',
    v1: `你在KKClash上下注了
    {27}次
    你對KKClash的熱愛戰勝了
    {28}的玩家`
    .replace("{27}", "{kkclash_num}")
    .replace("{28}", "{kkclash_win_num}"),
    v2: `你在KKClash上下注了
    {27}次
    感謝你的陪伴！`
    .replace("{27}", "{kkclash_num}")
  },

  winHands: {
    text: `其中，你最喜歡的選項是
    {29}
    總共下注了
    {30}次`
    .replace("{29}", "{win_hand}")
    .replace("{30}", "{win_hand_num}")
  },

  trophy: {
    text: `2024年，你一共解鎖了
    {31}項
    成就`
    .replace("{31}", "{trophy_num}"),
    endText:`今年KKPoker將與你一起解鎖更多成就。`,
    kk_title: `KK之王`,
    kk_desc: `用兩張K-K贏牌`,
    itm_title : `哎呀～不小心又錢圈啦！`,
    itm_desc: `MTT進錢圈`,
    bountry_title: `賞金獵人`,
    bountry_desc: `KO其他玩家`,
    nlh_title: `我什麼牌都會玩`,
    nlh_desc: `點亮地圖，解鎖獎杯`,
    aof_title:`All-in老是贏`,
    aof_desc: `點亮地圖，解鎖獎杯`,
    plo_title:`習慣手拿5張`,
    plo_desc: `用四條及以上牌型贏牌`,
    spin_title: `旋轉粉絲`,
    spin_desc: `SpinUp轉到≥ X5`,
    ofc_title:`菠蘿王`,
    ofc_desc: `Re-fantacy最高紀錄`
  },

  futureStory: `2024，KKPoker希望和你一起書寫後面的故事。`,

  version3: {
    text: `很遺憾，在2024年，你還沒有在KKPoker留下任何痕跡。
    2024，KKPoker希望和你一起書寫後面的故事。
    `,
  },

  button: {
    save: "Save Image",
    copy: "Copy and Share",
  },

  unit: {
    days: "天",
    hands: "手",
    times: "次",
  },
  toast: {
    linkCopied: "Link copied",
  },
};
